import React, {useEffect} from "react";
import styles from "./articlePage.component.less";

 import hljs from 'highlight.js';

import 'highlight.js/styles/stackoverflow-light.min.css';
const parser = new DOMParser();
function Article(props)
{
 
    let article = props.value;
    useEffect(() => {
        hljs.highlightAll()
      }, [props]);
    if(!article)
    return <span>loading...</span>;
    return (
        <div className={styles.wrapper}>
            <div>
                <h1>{article.title}</h1>
                <div dangerouslySetInnerHTML={{__html: props.value.content}}></div>
            </div>
        </div>
    );
}

export default Article;